namespace Matrix.Data {
    export class FieldCustomizationColumns {
        static columnsKey = 'Data.FieldCustomization';
    }
}
